export default __webpack_public_path__ + "static/media/chart-energy-trade.fcc8e885.svg";